import '../../style/index.less';
import './index.less';
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/skeleton/style/index.js
// module id = 1806
// module chunks = 0